// ADR 11.9.26i §2 — the two device-enrolment endpoints, one function each.
//
// The bodies are the phones' (`rust-core/src/client/device/enrol.rs`) with one
// subtraction the wire already allows for: no `attestation`. A browser has no
// platform attestation to offer, and `RegisterDeviceRequest.attestation` is
// `Option` on the server for exactly that case — "absent is the ordinary case
// … and is never an error" (`routes/device/mod.rs`). The token mints at the
// `pow` rung, which under `Soft` is the baseline every un-attested phone gets.
//
// Neither call is `anonymous: true`: these are the requests that *mint* the
// identity, so there is no token to carry yet — and on a renewal the outgoing
// token travels in the body, where the server reads it, not in a header, where
// this route never looks.

import { requestJson } from './http'

/**
 * `GET /device/challenge` — `DeviceChallengeResponse` (`routes/device/mod.rs`).
 *
 * `attest` is typed and ignored: it tells a phone whether to call Play
 * Integrity or App Attest before solving, and a browser has neither.
 */
export interface DeviceChallengeResponse {
  nonce: string
  difficulty: number
  ttl_seconds: number
  attest: boolean
}

/** The `POST /device/register` body. `outgoing_token` carries the tier and the quota identity forward on a renewal (7.8.26c D2/D3). */
export interface RegisterDeviceRequest {
  nonce: string
  solution: string
  outgoing_token: string | null
}

export interface RegisterDeviceResponse {
  device_token: string
}

export function deviceChallenge(): Promise<DeviceChallengeResponse> {
  return requestJson<DeviceChallengeResponse>('/device/challenge')
}

export function registerDevice(body: RegisterDeviceRequest): Promise<RegisterDeviceResponse> {
  return requestJson<RegisterDeviceResponse>('/device/register', { method: 'POST', body })
}
